<template>
  <div class="mod-success">
    <user-icon type="icon-roundcheckfill"></user-icon>
    <p v-html="successContent"></p>
    <div class="action">
      <a-button size="large" @click="onCancel">不了，谢谢</a-button>
      <a-button size="large" type="primary" @click="onOk">实名认证</a-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    successContent: String
  },
  methods: {
    onCancel () {
      window.__MICRO_ROOT__?.router?.replace('/')
    },
    onOk () {
      this.$router.replace({
        path: '/authenticate',
        query: {
          type: 'auth'
        }
      })
    }
  }
}
</script>
